import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import authService from './services/authService';
import store from './store';
import './assets/main.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.js';

// Crée une instance de l'application Vue
const app = createApp(App);

// Utilise le routeur et le store Vuex
app.use(router);
app.use(store);

// Monte l'application
app.mount('#app');

// ========== ENREGISTREMENT DU SERVICE WORKER ==========
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('✅ Service Worker enregistré:', registration.scope);
      })
      .catch((error) => {
        console.log('❌ Erreur Service Worker:', error);
      });
  });
}

// Ajouter un intercepteur pour inclure le token dans les en-têtes
axios.interceptors.request.use(config => {
  const token = authService.getToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Ajouter un intercepteur pour gérer les erreurs de réponse
axios.interceptors.response.use(response => {
  return response;
}, error => {
  if (error.response && error.response.status === 401) {
    // Si le token est expiré ou invalide, supprime le token et redirige vers la page de connexion
    authService.logout();
    store.dispatch('auth/checkAuthentication')
    router.push('/login');
  }
  return Promise.reject(error);
});
